
import { useSelector, useDispatch } from "react-redux";
import { Stack2 } from 'tabler-icons-react';

import { remove_user_todocs } from "../../slice/mainslice";
import { useEffect } from "react";
import { createStyles } from "@mantine/core";

const useStyles = createStyles((theme) => ({
  nopointer: {
    cursor: `default`,
  },
}));

const ShowStapelSignDocsforUser = (props: any) => {
  const { classes } = useStyles();
  const dispatch = useDispatch();


  const { userId, resourceId } = props;

  // Filter Selected Documents to User
  useEffect(() => {
    // Remove from Data to Sign Document to provide double entrys in both lists
    const removedata = {
      userId,
      resourceId,
    };

    dispatch(remove_user_todocs(removedata)); 

  }, [userId, resourceId, dispatch]); // Depend only on necessary values

  return (
    <>
      <span className={classes.nopointer}><Stack2/></span>
    </>
  );
};

export default ShowStapelSignDocsforUser;